import { useTranslation } from 'react-i18next';
import { OverviewKpiWidget } from './widgets/OverviewKpiWidget';
import { DocOpenPscLnpWidget } from './widgets/DocOpenPscLnpWidget';
import { DocOpenOtherWidget } from './widgets/DocOpenOtherWidget';
import { LotResiduoWidget } from './widgets/LotResiduoWidget';
import { PackagingStockWidget } from './widgets/PackagingStockWidget';
import { CategoryAggregateWidget } from './widgets/CategoryAggregateWidget';
import { MovementsInMonthWidget } from './widgets/MovementsInMonthWidget';
import { MovementsOutMonthWidget } from './widgets/MovementsOutMonthWidget';
import { UrgentiWidget } from './widgets/UrgentiWidget';
import { MancantiWidget } from './widgets/MancantiWidget';
import { GrammiNecessariWidget } from './widgets/GrammiNecessariWidget';

export function DashboardPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-slate-900">{t('dashboard.title')}</h2>

      <OverviewKpiWidget />

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <DocOpenPscLnpWidget />
        <DocOpenOtherWidget />
      </div>

      <h3 className="pt-2 text-lg font-semibold text-slate-800">{t('dashboard.sectionProduction')}</h3>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <UrgentiWidget />
        <MancantiWidget />
      </div>
      <GrammiNecessariWidget />

      <h3 className="pt-2 text-lg font-semibold text-slate-800">{t('dashboard.sectionInventory')}</h3>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
        <LotResiduoWidget />
        <PackagingStockWidget />
        <CategoryAggregateWidget />
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <MovementsInMonthWidget />
        <MovementsOutMonthWidget />
      </div>
    </div>
  );
}
